'use client';

import { styled } from '@mui/material';
import { Button } from '@nxt-costco-com/forge-components';
import {
    ColorBlue40,
    ColorTextLink,
    FontLineHeightLg,
    FontWeightRegular,
    SpaceMd,
} from '@nxt-costco-com/forge-design-tokens';

export const StyledButton = styled(Button)({
    padding: '4px 8px 4px 8px',
    fontSize: '14px',
    border: `1px solid ${ColorBlue40}`,
    color: ColorTextLink,
    margin: `0 ${SpaceMd} 0 0`,
    fontWeight: FontWeightRegular,
    lineHeight: FontLineHeightLg,
    backgroundColor: 'white',
    height: '32px',
    '&:hover': {
        backgroundColor: '#d9d9d9',
    },
    '&:focus': {
        backgroundColor: '#d9d9d9',
    },
});
